/* @flow */

import ApiModel, {
    type Options as ModelOptions,
    type Interceptor
} from './RequestAwareApiModel';
import EnvConfig from 'config';
import omit from 'lodash/omit';

type Options = {
    ...$Diff<ModelOptions, { baseUrl: string }>,
    baseUrl?: string
};

class LocusApiModel extends ApiModel {
    constructor({
        baseUrl = EnvConfig.dashboardEndPoint,
        ...otherOptions
    }: Options) {
        super({ baseUrl, ...otherOptions });
    }

    static defaultHeaders: { [name: string]: string } = {
        Accept: 'application/json'
    };

    static set401Interceptor(interceptor: Interceptor) {
        LocusApiModel.setDefaultInterceptor(
            (request, response) => interceptor(request, response),
            401
        );
    }

    getDefaultHeaders = function () {
        return LocusApiModel.defaultHeaders;
    };

    static setHeader(key: string, value: string) {
        LocusApiModel.defaultHeaders[key] = value;
    }
    static removeHeader(key: string) {
        LocusApiModel.defaultHeaders = omit(LocusApiModel.defaultHeaders, key);
    }
}

export type { Options as LocusApiModelOptions };
export default LocusApiModel;
